const NoDataProvidedMessage = ({ classNames }) => {
  return (
    <div className={"col-12 " + classNames}>
      No data has been provided in the entry.
    </div>
  );
};

export default NoDataProvidedMessage;
